import * as actions from './actionTypes';
import { setLoading, setMessage } from './general';
import axios from '../../config/axiosInstance';
import { toPng, getImage, transformLogo64 } from '../../shared/images';

export const fetchEmployerSuccess = data => ({
  type: actions.FETCH_EMPLOYER_SUCCESS,
  data,
});

export const fetchEmployer = companyCode => (dispatch) => {
  dispatch(setLoading(true));
  axios
    .get(`/company/companyCode/${companyCode}`)
    .then((response) => {
      dispatch(fetchEmployerSuccess(toPng(response.data)));
      dispatch(setLoading(false));
    })
    .catch((error) => {
      dispatch(setLoading(false));
      dispatch(setMessage(error));
    });
};

export const updateEmployer = (data, isModal) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .put('/company', getImage(data))
    .then((response) => {
      // dispatch(updateEmployerSuccess(response.data));
      //   document.location.reload()
      if (!isModal) {
        dispatch(setMessage('Empregador atualizado com sucesso'));
      }
      dispatch(setLoading(false));
      return Promise.resolve(response.data);
    }).then(() => {
      if (isModal) {
        axios.get('/company/register/optmy');
      }
    })
    .catch((error) => {
      dispatch(setLoading(false));
      dispatch(setMessage(error));
      return Promise.reject(error);
    });
};

export const updateEmployerSuccess = data => ({
  type: actions.UPDATE_EMPLOYER_SUCCESS,
  data,
});

export const getLogo64Success = logo => ({
  type: actions.GET_EMPLOYER_LOGO_SUCCESS,
  logo,
});

export const getLogo64 = logo => (dispatch) => {
  dispatch(setLoading(true));
  return transformLogo64(logo)
    .then((response) => {
      dispatch(getLogo64Success(response));
      dispatch(setLoading(false));
      return Promise.resolve(response);
    })
    .catch((error) => {
      dispatch(setLoading(false));
      dispatch(setMessage(error));
      return Promise.reject(error);
    });
};
